// customLocale.js
import persian_fa from "react-date-object/locales/persian_fa";
import persian from "react-date-object/calendars/persian";

const customLocale = {
  ...persian_fa,
  weekDays: [
    ["ش", "شنبه"],
    ["ی", "یکشنبه"],
    ["د", "دوشنبه"],
    ["س", "سه‌شنبه"],
    ["چ", "چهارشنبه"],
    ["پ", "پنج‌شنبه"],
    ["ج", "جمعه"],
  ],
};

export { persian, customLocale };
